var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManualLimit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24418",
    "data-name": "Group 24418",
    transform: "translate(12975 1044)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3615",
    "data-name": "Ellipse 3615",
    transform: "translate(-12975 -1044)",
    fill: "rgba(240,40,51,0.7)",
    stroke: "#f02833",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "notify3",
    transform: "translate(-12970.739 -1040)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5355",
    "data-name": "Rectangle 5355",
    width: 14,
    height: 14,
    transform: "translate(-0.262 0)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-notification_1_",
    "data-name": "icons8-notification (1)",
    d: "M9.2,2a.958.958,0,0,0-.976.938v.435A3.779,3.779,0,0,0,5.3,7v3.125h7.807V7a3.779,3.779,0,0,0-2.928-3.628V2.937A.958.958,0,0,0,9.2,2ZM4,11.375v1.25H8.079a1.212,1.212,0,0,0-.175.625,1.3,1.3,0,0,0,2.6,0,1.213,1.213,0,0,0-.177-.625h4.08v-1.25Z",
    transform: "translate(-2.467 -1.25)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualLimit);
export default __webpack_public_path__ + "static/media/manual_limit.a67ae3fa32a10b9a42f593dd091e0e1a.svg";
export { ForwardRef as ReactComponent };